import {useQuery} from '@tanstack/react-query';

import {getEventOrders, GetEventOrdersParams} from '../api';
import {QUERY__EVENT_ORDERS} from '../queryKeys';
import {Order} from '../types';

import {GetListOutput, QueryOptionsForList} from '@/shared/api';

export const useGetEventOrders = <SelectedData = GetListOutput<Order>>(
  params: GetEventOrdersParams,
  options?: QueryOptionsForList<Order, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__EVENT_ORDERS, params],
    queryFn: () => getEventOrders(params),
    ...options,
  });
};
